export const toneOfVoicesKeys = {
	all: ['toneOfVoices'],
	list: () => ['toneOfVoices', 'list'],
	detail: (id) => ['toneOfVoices', 'detail', id],
};
